{
  "name": "@fiberplane/agents",
  "version": "0.5.3",
  "description": "",
  "type": "module",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    }
  },
  "files": [
    "dist/",
    "package.json",
    "tsconfig.json",
    "CHANGELOG.md",
    "src/"
  ],
  "publishConfig": {
    "access": "public",
    "exports": {
      ".": {
        "types": "./dist/index.d.ts",
        "import": "./dist/index.js"
      }
    }
  },
  "scripts": {
    "dev": "pnpm run build && tsup --watch",
    "build": "tsx scripts/build.ts",
    "format": "biome format --write",
    "typecheck": "tsc --noEmit",
    "lint": "biome lint",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "keywords": [],
  "author": "",
  "license": "MIT/Apache-2.0",
  "dependencies": {
    "@hono/node-server": "^1.13.7",
    "@hono/node-ws": "^1.1.0",
    "agents": "^0.0.75",
    "ai": "^4.1.61",
    "chokidar": "^3.6.0",
    "cloudflare": "^4.2.0",
    "clsx": "^2.1.1",
    "hono": "^4.7.4",
    "jsonc-parser": "^3.3.1",
    "mime-types": "^2.1.35",
    "toml": "^3.0.0",
    "wrangler": "^4.1.0",
    "ws": "^8.18.1",
    "zod": "^3.24.2"
  },
  "devDependencies": {
    "@biomejs/biome": "^1.9.4",
    "@cloudflare/workers-types": "^4.20250317.0",
    "@modelcontextprotocol/sdk": "^1.8.0",
    "@types/ws": "^8.18.0",
    "tsup": "^8.3.5",
    "tsx": "^4.19.2",
    "typescript": "^5.8.2",
    "vite": "^6.2.2"
  }
}
